module.exports = __webpack_public_path__ + "img/icon14.1d2b402f.png";